import Utils from "../utils/utils";
import imagesLoaded from 'imagesloaded';
import emitter from 'tiny-emitter/instance';

class bulbPreload {
    constructor(){
        Utils.debug('BulbPreload : Construct');
        this.count = 0;
        this.countTotalImages = 0
        this.cb = [];
        this.objPercent = {};
    }

    loadImages(images) {

        let imgLoad = imagesLoaded(images);
        this.countTotalImages = images.length;
        imgLoad.on( 'progress', this.onProgress.bind(this) );
        imgLoad.on( 'done', this.onDone.bind(this) );
    }

    on(cbName, cb){
        this.cb[cbName] = cb;
    }


    dispatch(cbName, option = null){
        if(cbName in this.cb) {
            this.cb[cbName](option)
        }
    }

    onDone() {
        console.log('finished');
        this.dispatch('done');
    }

    onProgress( instance, image ) {
        if(image !== undefined) {
            this.count++;
            let objPercent = {
                assetCount : this.countTotalImages,
                currentCount: this.count,
                percent : (this.count * 100) / this.countTotalImages,
            }
            this.dispatch('progress', objPercent);
        }
    }

}


export default bulbPreload;



// WEBPACK FOOTER //
// ./scripts/core/bulbPreload.js